import { useEffect, useState } from 'react';
import axios from 'axios';
import '../../styles/Badges.css';
import { coverForBadge } from '../../catalogCovers';

export default function Badges() {
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    axios.get('/api/community/badges')
      .then(res => setBadges(Array.isArray(res.data) ? res.data : []));
  }, []);

  return (
    <div className="badges-container">
      <h2 className="badges-title">Badges</h2>
      <div className="badges-grid">
        {badges.map(badge => (
          <div key={badge.id} className="badge-card">
            <img src={coverForBadge(badge)} alt="" className="badge-icon" />
            <h3 className="badge-name">{badge.title || badge.name}</h3>
            <p className="badge-description">{badge.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
